<template>
    <div class="sub-nav-container pb-5">

        <jet-nav-link :href="route('dashboard')" :active="route().current('dashboard')">
            User List
        </jet-nav-link>

        <jet-nav-link :href="route('audit-logs')" :active="route().current('audit-logs')">
            Audit Logs
        </jet-nav-link>
    </div>
</template>

<style scoped>

</style>


<script>
    import JetNavLink from '@/Jetstream/NavLink'

    export default {
        components: {
            JetNavLink,
        }
    }
</script>
